import { createClientAndSessionStore } from '@zipdrug/react-api-sdk';
import { ApolloProvider } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import thunkMiddleware from 'redux-thunk';
import ContextProvider from 'contexts';
import observe from './redux/observe';
import reducers from './redux/reducers';
import RoutesComponent from './routes/Routes'; // Ensure this path is correct
import { API_WS_URL, API_HTTP_URL } from './settings';
import ErrorBoundary from './ErrorBoundary';
import RebrandingNotification from './login/RebrandingNotification';
import './App.less';
import { BrowserRouter as Router } from 'react-router-dom'; // Import Router

const saveSubsetBlacklistFilter = createBlacklistFilter('form', [
  'addressForm',
  'contactForm',
  'createWorkstationPhone',
  'enrollForm',
  'forgotPassword',
  'login',
  'phone',
  'register',
  'registerWorkstation',
  'resetPassword',
]);

const { client, sessionStore } = createClientAndSessionStore({
  blacklist: ['audio', 'filterPanel', 'modal', 'mutation'],
  middleware: [thunkMiddleware],
  persistOptions: {
    transforms: [saveSubsetBlacklistFilter],
  },
  reducers,
  wsUrl: API_WS_URL,
  httpUrl: API_HTTP_URL,
});

export const apolloClient = client.instance();
const store = sessionStore.getStore();


const identifyFullStoryUser = user => {
  if (!user) return null;
  return window.FS.identify(user.id, {
    displayName: `${user.first_name} ${user.last_name}`,
    email: user.email,
  });
};

// Identify user for FullStory on pageload
observe(store, 'session.user', identifyFullStoryUser);

// Check if current domain is an old zipdrug domain
const isOldDomain = () => {
  const hostname = window.location.hostname;
  const oldDomains = [
    'care.uat.zipdrug.com',
    'care.zipdrug-staging.com',
    'care.zipdrug.com'
  ];
  
  // Don't show rebranding if we already showed it in this session
  if (sessionStorage.getItem('rebrandingShown') === 'true') {
    return false;
  }
  
  return oldDomains.includes(hostname);
};

const App = () => {
  const [showRebranding, setShowRebranding] = useState(false);

  useEffect(() => {
    // Check if we should show rebranding notification
    if (isOldDomain()) {
      setShowRebranding(true);
    }
  }, []);

  // If old domain, show rebranding notification
  if (showRebranding) {
    return <RebrandingNotification />;
  }

  // Otherwise render normal app
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <ApolloProvider client={apolloClient}>
          <ContextProvider>
            <RoutesComponent />
          </ContextProvider>
        </ApolloProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default App;